import React from 'react';

const items = [
  'STATUS: CONECTADO',
  'JOGADORES ONLINE: +500',
  'DARDOS LANÇADOS HOJE: 128.940',
  'TORNEIOS ATIVOS: 12',
  'PING MÉDIO: 24MS',
  'DISPONÍVEL EM 2027',
  'SQUARE DARTS BRASIL',
  'REDE NACIONAL ATIVA',
];

export default function TopBar() {
  return (
    <div className="w-full bg-black border-b border-[rgba(34,230,230,0.25)] py-2 text-[12px] tracking-[0.2em] text-[color:var(--sd-cyan)]">
      <div className="marquee">
        <div className="marquee-track">
          {[...items, ...items].map((t, i) => (
            <span key={i} className="font-mono flex items-center gap-3">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[color:var(--sd-cyan)] shadow-[0_0_8px_var(--sd-cyan)]" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
